import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	validationErrorRatingRequired: {
		id: 'smart-create-feedback.emoji-rating-selector.validation.rating.required',
		defaultMessage: 'Please select a rating before submitting',
		description: 'Error message when rating is not selected',
	},
});
